import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ContactPreferencesIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/contact-preferences'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'contact_preferences_settings',
          component: ContactPreferencesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
